import React, { useEffect, useState } from "react";
import AppShell from "../../components/layout/AppShell";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Trophy, UsersThree } from "@phosphor-icons/react";

const PERIODS = ["daily", "weekly", "monthly", "yearly"];

export default function WorkforceLeaderboard() {
  const [period, setPeriod] = useState("monthly");
  const [data, setData] = useState(null);

  const load = async () => {
    try {
      const r = await api.get(`/workforce/leaderboard?period=${period}`);
      setData(r.data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, [period]);

  const rows = data?.rows || [];
  return (
    <AppShell title="Workforce Leaderboard" subtitle="Performance Ranking">
      <div className="flex gap-2 mb-4" data-testid="period-chips">
        {PERIODS.map(p => (
          <button key={p} data-testid={`period-${p}`}
                  onClick={() => setPeriod(p)}
                  className={`px-3 h-9 rounded-md text-xs uppercase tracking-[0.18em] border ${period === p ? "bg-[#2D5A27] text-white border-[#2D5A27]" : "bg-white border-[#E5E2D9] text-[#5C5A55]"}`}>
            {p}
          </button>
        ))}
      </div>

      <div className="bg-white border border-[#E5E2D9] rounded-md">
        <table className="w-full text-sm" data-testid="leaderboard-table">
          <thead>
            <tr className="bg-[#F7F6F2] text-left text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <th className="px-6 py-3 w-12">#</th>
              <th className="px-6 py-3">Staff</th>
              <th className="px-6 py-3">Code</th>
              <th className="px-6 py-3">Role</th>
              <th className="px-6 py-3 text-right">Tasks Done</th>
              <th className="px-6 py-3 text-right">Invoices</th>
              <th className="px-6 py-3 text-right">Billed (₹)</th>
              <th className="px-6 py-3 text-right">Score</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} className="px-6 py-12 text-center text-[#8A8780]">No activity this period.</td></tr>}
            {rows.map((r, i) => (
              <tr key={r.staff_id} className={i % 2 === 0 ? "bg-white" : "bg-[#FAFAF7]"} data-testid={`lb-row-${i}`}>
                <td className="px-6 py-3">
                  {i === 0 ? <Trophy size={20} color="#C89E3E" weight="fill" /> :
                   i === 1 ? <Trophy size={18} color="#8A8780" weight="fill" /> :
                   i === 2 ? <Trophy size={18} color="#A64D2E" weight="fill" /> :
                   <span className="font-mono text-[#8A8780]">{i + 1}</span>}
                </td>
                <td className="px-6 py-3 font-medium flex items-center gap-2">
                  <UsersThree size={16} color="#2D5A27" weight="duotone"/> {r.name}
                </td>
                <td className="px-6 py-3 font-mono text-xs text-[#5C5A55]">{r.staff_code || "—"}</td>
                <td className="px-6 py-3 capitalize text-xs">{r.role}</td>
                <td className="px-6 py-3 text-right font-mono">{r.tasks_done}</td>
                <td className="px-6 py-3 text-right font-mono">{r.invoices}</td>
                <td className="px-6 py-3 text-right font-mono">₹{Number(r.billed_total || 0).toLocaleString()}</td>
                <td className="px-6 py-3 text-right font-mono font-semibold text-[#2D5A27]">{Number(r.score || 0).toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
